import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Apply saved font scales on startup
try {
  const raw = localStorage.getItem('guestmsg-font-scales');
  if (raw) {
    const scales = JSON.parse(raw);
    const isMobile = window.innerWidth < 768;
    const active = isMobile ? scales.mobile : scales.desktop;
    if (active?.general) {
      document.documentElement.style.fontSize = `${active.general}%`;
    }
  }
} catch {}

createRoot(document.getElementById("root")!).render(<App />);
